import { type FetchDataSortBy, type DashTableStateSortingRule } from './dashTable.types'

export const tableSortByToFetchDataSortBy = (
  tableSortBy: DashTableStateSortingRule[]
): FetchDataSortBy | undefined => {
  if (tableSortBy.length === 0) return undefined

  return {
    id: tableSortBy[0].id,
    direction: tableSortBy[0].desc ? 'DESC' : 'ASC',
  }
}
